// React router dom imports
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Page imports
import Home from "./Home";
import NoMatch from "./NoMatch";
import Viewer from "./Viewer";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

function PageViewTracker() {
  const location = useLocation();
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname,
      title: document.title,
    });
  }, [location.pathname]);
  return null;
}

export default function AppRoutes() {
  // TimeoutHome component: sets localStorage and redirects to home
  function TimeoutHome() {
    useEffect(() => {
      localStorage.setItem("inactivityRedirectEnabled", "true");

      window.location.replace("/");
    }, []);
    return null;
  }

  return (
    <BrowserRouter>
      <PageViewTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/virtual/:sceneId" element={<Viewer />} />
        <Route path="/activate-demo-mode" element={<TimeoutHome />} />
        <Route path="*" element={<NoMatch />} />
      </Routes>
    </BrowserRouter>
  );
}
